/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

/*
Additional final check if medication name (key) is existing (in list of configured medications) and
source is set correctly (should normally have been done in CreatableAutocomplete).
 */
import _ from 'lodash';
import { Dose, Medication, MedicationSource, MedicationValue } from '../../../../backendModels/medication.model';
import { nonEmptyArray } from '../../../../utils/util';

export function validateMedicationSource(
  source: MedicationSource,
  name?: string,
  configuredMedications?: readonly Medication[]
): MedicationSource {
  if (source === MedicationSource.CONFIGURATION && name && nonEmptyArray(configuredMedications)) {
    const isConfiguredMedication = _.some(configuredMedications, { key: name });
    if (!isConfiguredMedication) {
      console.warn(
        `Medication source was corrected to "CUSTOM" because "${name}" was not found in list of configured medications.`
      );
    }
    return isConfiguredMedication ? MedicationSource.CONFIGURATION : MedicationSource.CUSTOM;
  }
  return source;
}

export function createMedication(
  source: MedicationSource,
  name?: string,
  dose?: Dose,
  applicationMethod?: string,
  configuredMedications?: readonly Medication[]
): MedicationValue {
  source = validateMedicationSource(source, name, configuredMedications);
  if (source === MedicationSource.CONFIGURATION) {
    return {
      key: name,
      dose: dose,
      applicationMethod: applicationMethod,
      source,
    };
  } else {
    return {
      customActiveSubstance: name,
      dose: dose,
      applicationMethod: applicationMethod,
      source,
    };
  }
}
